import { CLASS_ACTIVE, CLASS_HIDDEN, CLASS_VISIBLE } from "../tools/constants/classes";

const SELECTOR_INPUT = '[data-search-input]';
const SELECTOR_SUBMIT = '[data-search-submit]';
const SELECTOR_CLEAR = '[data-search-clear]';

class SearchResults extends HTMLElement {
  private input: HTMLInputElement | null;
  private submitButton: HTMLButtonElement | null;
  private clearButton: HTMLButtonElement | null;

  constructor() {
    super();

    this.input = this.querySelector(SELECTOR_INPUT);
    this.submitButton = this.querySelector(SELECTOR_SUBMIT);
    this.clearButton = this.querySelector(SELECTOR_CLEAR);
    
    if (!this.input || !this.submitButton || !this.clearButton) return;

    this.init();
  }

  private init(): void {
    this.updateButtonVisibility();
    
    if (this.input) {
      this.input.addEventListener('input', this.debounce(() => {
        this.onChange();
      }, 300).bind(this));
    }
    
    this.clearButton?.addEventListener('click', () => {
      if (!this.input) return;
      this.input.value = ''; 
      this.clearButton?.classList.remove(CLASS_ACTIVE);
      this.input.focus(); 
      this.updateButtonVisibility();
    });
  }

  onChange() {
    this.updateButtonVisibility();
  }

  updateButtonVisibility() {
    if (!this.input || !this.submitButton || !this.clearButton) return;
    
    const hasValue = this.input.value.trim().length > 0;
    
    if (hasValue) {
      this.clearButton.classList.remove(CLASS_HIDDEN);
      this.clearButton.classList.add(CLASS_VISIBLE);
    } else {
      this.clearButton.classList.remove(CLASS_VISIBLE);
      this.clearButton.classList.add(CLASS_HIDDEN);
    }
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('search-results', SearchResults);
